export const SEGMENT_OPTIONS = [
  { value: "", label: "All segments" },
  { value: "retailer", label: "Retailer" },
  { value: "wholesale", label: "Wholesale" },
  { value: "hotel", label: "Hotel" },
  { value: "restaurant", label: "Restaurant" },
  { value: "event", label: "Event" },
  { value: "canteen", label: "Canteen" },
  { value: "family", label: "Family" }
];

export const STATUS_OPTIONS = [
  { value: "", label: "All status" },
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" }
];

